import { enqueueSnackbar } from 'notistack'

/**
 * Show messages to user in a snackbar. It is a wrapper function of notistack. Check out notistack for full documentation https://notistack.com/getting-started
 * @param {string} message - Message to be displayed
 * @param {string} variant -  default | error | success | warning | info
 * @param {Object} options - Additional options to be added refer https://notistack.com/getting-started#enqueuesnackbar-options
 */
export const alertMsg = (message, variant = 'default', options = {}) => {
    return enqueueSnackbar(message, {
        autoHideDuration: 3000,
        anchorOrigin: { horizontal: "right", vertical: "top" },
        variant: variant,
        ...options
    })
}

export const urltoFile = (url, filename, mimeType) => {
    if (url.startsWith('data:')) {
        var arr = url.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        var file = new File([u8arr], filename, { type: mime || mimeType });
        return Promise.resolve(file);
    }
    return fetch(url)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], filename, { type: mimeType }));
}

export const urlToBLOB = async (url) => {
    const response = await fetch(url)
    const blob = await response.blob()
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    // return reader.result
    return new Promise((res) => {
        reader.onloadend = () => {
            res(reader.result);
        }
    })
}
/**
 * Converts bytes into human readable string
 * @param {Number} size - Size in bytes
 * 
 */
export const humanFileSize = (size) => {
    let i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

export const kFormatter = (num) => {
    return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(2)) + 'K' : (Math.sign(num) * Math.abs(num)).toFixed(2)
}
export const getRoleNameFromRoleId = (roleId) => {
    switch (roleId) {
        case 2:
            return 'Admin'
        case 5:
            return 'Client'
        case 4:
            return 'Editor'
        case 3:
            return 'QC'
        default:
            return 'unknown'
    }
}